import React from 'react';
import './Porfolio.scss';
import PieChart from '../../commons/pie-chart/PieChart';

class Rent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentFund: "",
      load: false,
      arrayPies: [],
      currentDateRange: ""
    };
  }

  componentDidMount() {
    const { funds, ManagedPortfolioChart } = this.props;
    let arrayPies = []
    let load = false;
    // const currentFund = funds.list.length > 0 ? funds.list[0].id : '';
      let activeFund = funds.list.find( item => item.active === true);
      const currentFund = funds.list.length > 0 ? activeFund.id : '';

    arrayPies = funds.list.map((itemX)=>{
      const temporal = [];
        ManagedPortfolioChart.forEach((itemY) => {
          if (itemY.fondo === itemX.id ) {
            temporal.push(itemY);
          }
        });
      return {
        pie: temporal,
        foundId: itemX.id
      }
    })
    load = true;
    const currentDateRange =
      funds.dateRange.length > 0 ? funds.dateRange[0].text : "";
    this.setState({ currentFund, load, arrayPies, currentDateRange });
  }

  renderPie = () => {
    if(this.state.load) {
      const {arrayPies, currentFund} = this.state;
      return (arrayPies.map((item, index)=>{
        let pie
        if (item.foundId === currentFund) {
          pie = <div key={index}>
            <PieChart data={item.pie} identificador="6"/>
                  </div>
        }
        return pie
      }));
    } else {
      return (
          <p>
            loading ...
          </p>
      );
    }
  }

  onChangeValue = (name, value) => {
    const aux = this.state[name];
    const { funds } = this.props;
    const range = funds.dateRange.find(item => item.fund_id === value);
    if (value !== aux) {
      this.setState({ [name]: value, currentDateRange: range.text });
    }
  }

  render() {
    const { funds, information } = this.props;
    const { currentDateRange } = this.state;
    // const tagStrong = (() => {
    //   const date = new Date();
    //   const currentYear = date.getFullYear();
    //   return <strong>{currentYear}</strong>;
    // })
    return (
      <div id={'cartera-administrada'} className={`container hbi-section-porfolio grafico6`}>
        <div className={`text-center`}>
          <h2>{information.title}</h2>
          <p>
            {information.subTitle} / <strong>{currentDateRange}</strong>
          </p>
        </div>
        <div className={`hbi-content-tabs-fondo`}>
          <ul className={`hbi-tabs-fondo`}>
            {funds.list.map(fund => (
              <li
                key={fund.id}
                className={`hbi-item-fondo ${
                  this.state.currentFund === fund.id
                    ? "hbi-item-fondo--active"
                    : ""
                }`}
                onClick={() => this.onChangeValue("currentFund", fund.id)}
              >
                {fund.name}
              </li>
            ))}
          </ul>
        </div>
        {this.renderPie()}
      </div>
    );
  }
}

export default Rent;
